import * as e from "react";
const t = (a) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.85 6.06A3.52 3.52 0 0121 9.5a3.5 3.5 0 01-6.96.5H14a3 3 0 112.85-3.94zm-6.77.145a4.001 4.001 0 003.16 4.723 4.501 4.501 0 007.605 1.555l-.047-.053A4.5 4.5 0 0117.5 20H6a4 4 0 01-.97-7.88 5.502 5.502 0 014.835-5.893l.215-.022zM16 11.26a4.499 4.499 0 013.182.063 2.5 2.5 0 01-4.153-1.474l-.13-.85H14a2 2 0 01-1.911-2.583A5.504 5.504 0 0116 11.26z",
      fill: "#2d6ded"
    }
  )
);
export {
  t as default
};
